import VerticalButton from './VerticalButton';
import type { VerticalButtonProps } from './VerticalButton';

export type { VerticalButtonProps };
export default VerticalButton;
